import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getFilenameSearchApiQuery } from '@/lib/photos/filename-search'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'

const PHOTO_SEARCH_DEBOUNCE_MS = 300

export function usePhotoSearchQuery(filenameQuery: string) {
  const trimmed = filenameQuery.trim()
  const apiQuery = getFilenameSearchApiQuery(trimmed)
  const [debouncedApiQuery, setDebouncedApiQuery] = useState<string | null>(null)

  useEffect(() => {
    if (apiQuery == null) {
      setDebouncedApiQuery(null)
      return
    }

    const timeoutId = window.setTimeout(() => {
      setDebouncedApiQuery(apiQuery)
    }, PHOTO_SEARCH_DEBOUNCE_MS)

    return () => window.clearTimeout(timeoutId)
  }, [apiQuery])

  const enabled = apiQuery != null && debouncedApiQuery === apiQuery

  return useQuery({
    queryKey: queryKeys.photos.searchPhotos(debouncedApiQuery ?? trimmed),
    queryFn: () => photosService.searchPhotosByFilename(debouncedApiQuery!),
    enabled,
    staleTime: 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
